import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";
import SucessImage from '../../assets/Success.png';
import ErrorImage from '../../assets/error.png'
import { mainColor } from "../../constants";
const StateDialog = ({open,handleClose,header,state="success",text,size="md"}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={size}
      
    >
      <DialogTitle id="alert-dialog-title">{header}</DialogTitle>
      <DialogContent>
        <div style={{
          display:"flex",
          flexDirection:"column",
          justifyContent:"center",
          alignItems:"center",
          minWidth:500
        }}>
          <img src={state=="success"?SucessImage:ErrorImage} width={200} height={200} />
          <Typography color={state=="success"?"green":"red"} variant="h6">{text}</Typography>

        </div>
      </DialogContent>
      <DialogActions>
            <button onClick={handleClose} style={{
                backgroundColor:mainColor,
                color:"white",
                border:" 1px solid #E5E7EB",
                padding:5,
                borderRadius:5,
                cursor:"pointer",
                minWidth:150,
                textAlign:"center" ,
            }} 
                >Ok</button>
      </DialogActions>
    </Dialog>
  );
};

export default StateDialog;
